import { render } from "./staymarquis-icon-container.svg.vue?vue&type=template&id=78f7c42a"
import script from "./staymarquis-icon-container.svg.vue?vue&type=script&lang=js"
export * from "./staymarquis-icon-container.svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__